import { createSelector } from 'reselect';
import get from 'lodash/get';
import resolveComplaint from './resolveComplaint';

const selectComplaintsState = state => get(state, 'complaints');

/**
 *  RESOLVED LIST
 * */

export const selectResolvedListState = createSelector(
  selectComplaintsState,
  state => get(state, 'resolvedList'),
);

export const selectResolvedList = createSelector(
  selectResolvedListState,
  state => get(state, 'list', []),
);

export const selectResolvedListPagination = createSelector(
  selectResolvedListState,
  state => get(state, 'pagination', {}),
);

/**
 *  UN-RESOLVED LIST
 * */

export const selectUnResolvedListState = createSelector(
  selectComplaintsState,
  state => get(state, 'unresolvedList'),
);

export const selectUnResolvedList = createSelector(
  selectUnResolvedListState,
  state => get(state, 'list', []),
);

export const selectUnresolvedListPagination = createSelector(
  selectUnResolvedListState,
  state => get(state, 'pagination', {}),
);

export const selectComplaintsLoading = createSelector(
  selectResolvedListState,
  selectUnResolvedListState,
  (resolvedState, unresolvedState) =>
    get(resolvedState, 'sending') || get(unresolvedState, 'sending'),
);

export const selectReportMenuItemVisible = createSelector(
  selectUnResolvedListState,
  state => get(state, 'reportsVisible'),
);

/**
 *  COUNTERS
 * */
export const selectComplaintsCountersState = createSelector(
  selectComplaintsState,
  state => get(state, 'counters'),
);

export const makeSelectComplaintsCounter = type =>
  createSelector(
    selectComplaintsCountersState,
    state => get(state, type),
  );

/**
 *  COMPLAINT DETAILS
 * */
export const selectComplaintDetailsState = createSelector(
  selectComplaintsState,
  state => get(state, 'details'),
);

export const selectComplaintDetails = createSelector(
  selectComplaintDetailsState,
  state => get(state, 'data'),
);

export const selectComplaintDetailsLoading = createSelector(
  selectComplaintDetailsState,
  state => get(state, 'sending'),
);

export const selectResolveComplaintState = createSelector(
  selectComplaintsState,
  state => get(state, 'resolveComplaint'),
);

export const selectResolveComplaintLoading = createSelector(
  selectResolveComplaintState,
  state => get(state, 'sending'),
);



// WEBPACK FOOTER //
// ./src/redux/complaints/selectors.js